import React from "react";

/**
 * Loading spinner that follows body theme (light_theme vs dark),
 * matching TVChartContainer / chart loader colors.
 */
export default function ThemeAwareSpinner({
    className = "",
    size = "md",
    as: Tag = "div",
    role = "status",
    label = "Loading",
    ...rest
}) {
    const sizeClass = size === "sm" ? "spinner-border-sm" : "";
    return (
        <Tag
            className={`spinner-border agce-theme-spinner ${sizeClass} ${className}`.trim()}
            role={role}
            {...rest}
        >
            {Tag !== "span" ? <span className="visually-hidden">{label}</span> : null}
        </Tag>
    );
}
